export default __webpack_public_path__ + "static/media/Robopac.5a6bc17b.png";